<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    children,
    anchorLeftPosition,
    position,
  }: {
    children?: Snippet;
    anchorLeftPosition: number | false;
    position?: "top" | "bottom";
  } = $props();

  let host = $state<HTMLElement>();
  let anchorPositionProperty = $derived.by(() => {
    if (anchorLeftPosition === false) return false;

    const radiusLeft = host
      ? parseFloat(getComputedStyle(host).getPropertyValue("border-top-left-radius"))
      : 0;
    const radiusRight = host
      ? parseFloat(getComputedStyle(host).getPropertyValue("border-top-right-radius"))
      : 0;
    let arrowWidth = host
      ? parseFloat(getComputedStyle(host).getPropertyValue("--bubble-arrow-width"))
      : 0;
    /*                                                                                   */
    /*                                    */
    if (isNaN(arrowWidth)) {
      arrowWidth = host
        ? parseFloat(getComputedStyle(host).getPropertyValue("--bubble-arrow-height")) * 2
        : 0;
    }
    const width = host ? host.offsetWidth : 0;
    const insetLeft = radiusLeft + arrowWidth / 2;
    const insetRight = width - (radiusRight + arrowWidth / 2);
    if (insetRight < insetLeft) return `50%`;
    if (anchorLeftPosition < insetLeft) return `${insetLeft}px`;
    if (anchorLeftPosition > insetRight) return `${insetRight}px`;
    return `${anchorLeftPosition}px`;
  });
</script>

<div class="bubble" data-position={position}>
  <div class="body" bind:this={host}>
    <div class="content">
      {@render children?.()}
    </div>
    {#if anchorLeftPosition !== false}
      <span class="arrow" style={`left: ${anchorPositionProperty}`}></span>
    {/if}
  </div>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  :global {
    $seamFixHeight: 1px;

    .bubble {
      /*                */
      pointer-events: none;
      margin-bottom: var(--bubble-vertical-offset);
      margin-top: var(--bubble-vertical-offset);

      --bubble-vertical-offset: calc(var(--bubble-context-spacing) + var(--bubble-arrow-height));
      .body {
        filter: var(--bubble-shadow-filter);
        pointer-events: all;
        position: relative;
        background-color: var(--bubble-background-color);
        color: var(--bubble-copy-color);
        border-radius: var(--bubble-border-radius);
        font: var(--bubble-copy-font);
      }

      .content {
        /*                                                                                              */
        padding: var(--bubble-padding);
        overflow: hidden;
      }
      .arrow {
        width: calc(var(--bubble-arrow-width) + $seamFixHeight * 2);
        height: calc(var(--bubble-arrow-height) + $seamFixHeight);
        margin-top: $seamFixHeight;
        background-color: var(--bubble-background-color);
        clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
        transform-origin: center;
        position: absolute;
        bottom: calc(-1 * var(--bubble-arrow-height) + #{$seamFixHeight - 1});
        left: 50%;
        transform: translate(-50%, 0%) rotate(180deg);
        z-index: 9999;
      }
      &[data-position="bottom"] {
        margin-bottom: 0;

        .arrow {
          bottom: auto;
          top: #{$seamFixHeight - 1};
          transform: translate(-50%, -100%);
        }
      }
      &[data-position="top"] {
        margin-top: 0;
      }
    }
  }
</style>
